var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-detail-container"},[_c('div',{staticClass:"module-content"},[_c('div',{staticClass:"module-specific-image"},[_c('img',{attrs:{"src":_vm.currentModule.url,"alt":_vm.currentModule.title}})])]),_c('bottom-url')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }